<template>
  <div class="DataTables QuickViewBomPartComponent ">
    
    <p v-if="isAssembly">{{lang.infotext_2}}:</p>
    <div v-if="isData && isAssembly" :id="idAssembly"></div>

    <p>{{lang.infotext_1}}: {{selectedMatchedPart}}</p>
    <div v-if="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import LibraryTypes from '@/constants/LibraryTypes'
  import PartPropertiesType from '@/constants/PartPropertiesType'
  import LibraryPropertiesType from '@/constants/LibraryPropertiesType'

    import $ from 'jquery';
    import dt from 'datatables.net-bs4';
    import { mapGetters } from 'vuex'


  export default {
    name: "QuickViewBomPartComponent",
    props:{
      lang: Object
    },
    components: {

      LoaderComponent
    },
    data () {
        return {

          mainTable: "",
          mainTableAssembly: "",
          packeges: [],
          packagesHDL: [],
          currentPackage: 0,
          currentHDLPackage: 0,
          currentSymbolObject: {
            name: "",
            type: ""
          },
          currentHDLSymbolObject: {
            name: "",
            type: ""
          },
          place: "",
          placeHDL: "",
          symbolTrig: false,
          symbolHDLTrig: false,
          footprintTrig: false,
          libraryType: "",
        }
    },
    computed: {
      id(){
        let id = "quickViewBomTable";
        if (this.parent == "Search"){
          id = id + "_Search";

        }
        return id;
      },
      idAssembly(){
        let id = "quickViewTableAssembly";
        if (this.parent == "Search"){
          id = id + "_Search";

        }
        return id;
      },
      revisionId(){

        return this.$store.getters.selectedPartBomRow.revisionId;


      },
      partId() {
        if (this.$store.getters.selectedPartBomRow.partId != undefined) {
          return this.$store.getters.selectedPartBomRow.partId;
        }
        return null;
      },
      isAssembly(){
        
        if (this.$store.getters.selectedPartBomRow.assembly != undefined) {
          if (this.$store.getters.selectedPartBomRow.assembly === true) {
            return true;
          } 
          //return this.$store.getters.selectedPartBomRow.assembly;
        }
        return false;
      },
      selectedMatchedPart(){
          

        return this.$store.getters.selectedPartBomRow.PartNumber;
      },
      isData(){

        return this.revisionId != undefined;


      },
      variant() {
        if (this.$store.getters.s_skinVariant == "dark") {
          return "light";
        } else {
          return "dark";
        }

      },

    },
    created () {
      

      let vue = this;

      let obj1 ={
        assemblyRevisionId: this.revisionId
      }
      let obj ={}
      if (this.$store.getters.sectionPrefix == "projm"){
        obj ={
          revisionId: this.revisionId
        }
      }else{
        obj ={
          revisionId: this.revisionId
        }
      }

      if (this.isAssembly  == true){
        this.$store.dispatch("getAssemblyElements", obj1)
        .then(function(result) {
          console.log(result)

          
          vue.prepareDataAssembly(result.data)

        })
      }
      let action = "pm_getQuickView"
  
      if (this.$store.getters.selectedPartBomRow.libraries == true) {
        action = "lm_getQuickView"
      }
      this.$store.dispatch(action, obj)
      .then(function(result) {
        console.log(result)

        if (result.status == "OK"){
          result.data.sort(function (a, b) { return a.priority - b.priority });

          let data = result.data;

          if (action == "pm_getQuickView") {
            let objPh = {
              partId: vue.partId
            }



            vue.$store.dispatch("pm_getPhysicals", objPh)
              .then(function (result) {
                console.log(result.data)
                if (result.data.length > 0) {
                  vue.mpn_image = result.data[0].imageUrl;


                  if ((result.data[0].imageUrl.indexOf("http://") != -1) || (result.data[0].imageUrl.indexOf("https://") != -1)) {
                    let obj = {
                      id: 0,
                      priority: 0,
                      name: "MPN image",
                      type: "mpn_image",
                      value: {
                        display: result.data[0].imageUrl
                      }
                    }
                    data.unshift(obj);
                  }
                  
                } else {
                  vue.mpn_image = "";
                }

                vue.prepareData(data);

              })
          } else {
            vue.prepareData(data);
          }

          

        }
        

      })

    },
    watch: {
      revisionId: function (newVal, oldVal) {
        
        let vue = this;

        let obj1 ={
          assemblyRevisionId: newVal
        }
        let obj ={}
      if (this.$store.getters.sectionPrefix == "projm"){
        obj ={
          revisionId: this.revisionId
        }
      }else{
        obj ={
          revisionId: this.revisionId
        }
      }

        if (this.isAssembly  == true){
          this.$store.dispatch("getAssemblyElements", obj1)
          .then(function(result) {
            
            console.log(result)

            vue.prepareDataAssembly(result.data)

          })
        }
        
        let action = "pm_getQuickView"
        
        if (this.$store.getters.selectedPartBomRow.libraries == true) {
          action = "lm_getQuickView"
        }
        this.$store.dispatch(action, obj)
        .then(function(result) {
          
          console.log(result)
          if (result.status == "OK"){

            result.data.sort(function (a, b) { return a.priority - b.priority });

            let data = result.data;

            if (action == "pm_getQuickView") {
              let objPh = {
                partId: vue.partId
              }



              vue.$store.dispatch("pm_getPhysicals", objPh)
                .then(function (result) {
                  console.log(result.data)
                  if (result.data.length > 0) {
                    vue.mpn_image = result.data[0].imageUrl;


                    if ((result.data[0].imageUrl.indexOf("http://") != -1) || (result.data[0].imageUrl.indexOf("https://") != -1)) {
                      let obj = {
                        id: 0,
                        priority: 0,
                        name: "MPN image",
                        type: "mpn_image",
                        value: {
                          display: result.data[0].imageUrl
                        }
                      }
                      data.unshift(obj);
                    }
                    console.log(data)
                  } else {
                    vue.mpn_image = "";
                  }

                  vue.prepareData(data);

                })
            } else {
              vue.prepareData(data);
            }

            
          }

        })

      },
      currentPackage: function (newVal, oldVal) {



        let barValue = document.getElementById("barValue");
        if (barValue != null) {
          let index = this.currentPackage + 1;
          barValue.value = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length + ")";

          let leftbar = document.getElementById("leftbar_" + this.id);
          let rightbar = document.getElementById("rightbar_" + this.id);

          if (this.currentPackage == 0) {
            leftbar.disabled = true;
          } else {
            leftbar.disabled = false;
          }

          if (this.currentPackage == this.packages.length - 1) {
            rightbar.disabled = true;
          } else {
            rightbar.disabled = false;
          }



          for (var i = 0, le = this.packages.length; i < le; i++) {
            var layer = "PACKAGES_" + this.packages[i];

            if (i == this.currentPackage) {
              if (this.place.getElementsByClassName(layer)[0] != undefined) {
                this.place.getElementsByClassName(layer)[0].style["visibility"] = "visible";
              }


            } else {
              if (this.place.getElementsByClassName(layer)[0] != undefined) {
                this.place.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
              }
            }


          }
        }

        const obj = {
          currentSymbolName: this.currentSymbolObject.name,
          currentPackage: this.packages[this.currentPackage],

        }

        //this.$store.dispatch("setCurrentSymbol", obj);

      },
      currentHDLPackage: function (newVal, oldVal) {



        let barValue = document.getElementById("barHDLValue");
        if (barValue != null) {
          let index = this.currentHDLPackage + 1;
          barValue.value = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";

          let leftbar = document.getElementById("leftbarHDL_" + this.id);
          let rightbar = document.getElementById("rightbarHDL_" + this.id);
          
          if (this.currentHDLPackage == 0) {
            leftbar.disabled = true;
          } else {
            leftbar.disabled = false;
          }

          if (this.currentHDLPackage == this.packagesHDL.length - 1) {
            rightbar.disabled = true;
          } else {
            rightbar.disabled = false;
          }



          for (var i = 0, le = this.packagesHDL.length; i < le; i++) {
            var layer = "PACKAGES_" + this.packagesHDL[i];

            if (i == this.currentHDLPackage) {
              if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "visible";
              }


            } else {
              if (this.placeHDL.getElementsByClassName(layer)[0] != undefined) {
                this.placeHDL.getElementsByClassName(layer)[0].style["visibility"] = "hidden";
              }
            }


          }
        }

        const obj = {
          currentHDLSymbolName: this.currentHDLSymbolObject.name,
          currentHDLPackage: this.packagesHDL[this.currentHDLPackage],

        }

        //this.$store.dispatch("setCurrentSymbol", obj);

      },
      currentSymbolObject: function (newVal, oldVal) {

        let vue = this;

        let idL = "libsymbolprop__" + vue.revisionId;

        const objL = {
          type: PartPropertiesType.PART,
          name: newVal.name,
          idL: idL
        }

        this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
          .then((result) => {
            console.log(result)
            if (result.data != null) {



              vue.loadLibraryProps(result.data, PartPropertiesType.PART);


            } else {
              vue.cleanLibraryProps(idL);
            }

          })

      },
      currentHDLSymbolObject: function (newVal, oldVal) {

        let vue = this;

        let idL = "libHDLsymbolprop__" + vue.revisionId;

        const objL = {
          type: LibraryTypes.HDLSYMBOL,
          name: newVal.name,
          idL: idL
        }

        this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
          .then((result) => {
            console.log(result)
            if (result.data != null) {



              vue.loadLibraryProps(result.data, LibraryTypes.HDLSYMBOL);


            } else {
              vue.cleanLibraryProps(idL);
            }

          })

      }
    },
    updated() {
      
    },
    mounted: function () {

    },
    methods: {
        buildSymbolViewer(place, revisionId){
        
          let vue = this;
          
          //let svg  = doc.firstChild

          this.place = place;
          let barid = "bar_" + this.place.id;
          
          
          let symbolbar = document.getElementById(barid + "_" + this.id);
          
          if (symbolbar != null){
            symbolbar.innerHTML = "";
          
            let group = place.getElementsByTagName(`g`);
            
            this.packages = [];
            this.currentPackage = 0;
            for (let i = 0, lei = group.length; i < lei; i++){
              
              let temp = group[i].className.baseVal.split("_");
              if (temp[0] == "PACKAGES"){
                this.packages.push(temp[1])
              }
            }
      

            if(this.packages.length > 1){
              
              //this.symbolSvg = svg;

              
              let index = this.currentPackage + 1;
              let valueBar = this.packages[this.currentPackage] + " (" + index + "/" + this.packages.length +")";

              const bar = `<div role="group" class="input-group  input-group-sm">
                          <div class="input-group-prepend">
                          <button disabled="disabled" id="leftbar_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant +` btn-bar">&lt;</button>
                          </div> 
                          <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="barValue" value="`+ valueBar +`" style="text-align:center;"> 
                          <div class="input-group-append">
                          <button id="rightbar_`+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&gt;</button>
                          </div>
                          </div>`;

              symbolbar.innerHTML = bar;

              let leftbar = document.getElementById("leftbar_" + this.id);
              leftbar.addEventListener("click", function(e) {
                
                if (vue.currentPackage == 0){
                  
                }else{
                  
                  vue.currentPackage--;
                }
                
              })
              let rightbar = document.getElementById("rightbar_" + this.id);
              rightbar.addEventListener("click", function(e) {
                
                if (vue.currentPackage == vue.packages.length){
                  
                }else{
                  
                  vue.currentPackage++;
                }
              })

              


            }else{
              //this.symbolSvg = {};
            }
          }
          

        if (this.$store.getters.sectionPrefix == "pm"){
          let place = "symbol_select_" + vue.id;
          
          
          let symbol_select = document.getElementById(place);
          
          symbol_select.addEventListener("change", function(e){
            
            let id = "symbol__" + vue.revisionId;
            if (vue.parent == "Search"){
              id = "searchsymbol__" + vue.revisionId;
            }
            if (vue.parent == "modalSearchParts") {
              id = "modalSearchPartssymbol__" + vue.revisionId;
            }

            let type = this.dataset.type;

            vue.currentSymbolObject.name = this.value;

            let img = document.getElementById("symbol__" + vue.revisionId);
            if (img != null) {
              img.dataset.name = this.value;
            }

            

            const obj = {
              type: LibraryTypes.PART,
              name: this.value,
              id: id,
              revisionId: vue.revisionId
            }
            
            
              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
              .then((result) => {
                
                if (result != null){
                  
                  let id = result.id;
                                            
                  vue.loadSVG(result, id, vue.revisionId, LibraryTypes.PART);
                  
                  
                }
              
              })
            

          })
        }
        if (this.$store.getters.sectionPrefix == "projm") {
          let place = "symbol_select_" + vue.id;


          let symbol_select = document.getElementById(place);
          
          symbol_select.addEventListener("change", function (e) {

            let id = "symbol__" + vue.revisionId;
            
            
            vue.currentSymbolObject.name = this.value;

            let img = document.getElementById("symbol__" + vue.revisionId);
            if (img != null) {
              img.dataset.name = this.value;
            }

            const obj = {
              type: LibraryTypes.PART,
              name: this.value,
              id: id,
              revisionId: vue.revisionId
            }

            
            vue.$store.dispatch("pm_getSvg", obj)
              .then((result) => {

                if (result != null) {

                  let id = result.id;

                  vue.loadSVG(result, id, vue.revisionId, LibraryTypes.PART);


                }

              })


          })
        }
          

          // const obj = {
          //   currentSymbolName: this.currentSymbolObject.name,
          //   currentPackage: this.packages[this.currentPackage],
            
          // }
          
          //this.$store.dispatch("setCurrentSymbol", obj);

        },
      buildHDLSymbolViewer(place, revisionId) {

        let vue = this;

        //let svg = doc.firstChild

        this.placeHDL = place;
        let barid = "bar_" + this.placeHDL.id;

        
        let symbolbar = document.getElementById(barid + "_" + this.id);
        
        if (symbolbar != null) {
          symbolbar.innerHTML = "";

          let group = place.getElementsByTagName(`g`);

          this.packagesHDL = [];
          this.currentHDLPackage = 0;
          for (let i = 0, lei = group.length; i < lei; i++) {

            let temp = group[i].className.baseVal.split("_");
            if (temp[0] == "PACKAGES") {
              this.packagesHDL.push(temp[1])
            }
          }


          if (this.packagesHDL.length > 1) {

            //this.symbolSvg = svg;



            let index = this.currentHDLPackage + 1;
            let valueBar = this.packagesHDL[this.currentHDLPackage] + " (" + index + "/" + this.packagesHDL.length + ")";

            const bar = `<div role="group" class="input-group  input-group-sm">
                          <div class="input-group-prepend">
                          <button disabled="disabled" id="leftbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&lt;</button>
                          </div> 
                          <input type="text" disabled="disabled" class="form-control form-control-sm input-viewer" id="barHDLValue" value="`+ valueBar + `" style="text-align:center;"> 
                          <div class="input-group-append">
                          <button id="rightbarHDL_`+ this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&gt;</button>
                          </div>
                          </div>`;

            symbolbar.innerHTML = bar;

            let leftbar = document.getElementById("leftbarHDL_" + this.id);
            leftbar.addEventListener("click", function (e) {

              if (vue.currentHDLPackage == 0) {

              } else {

                vue.currentHDLPackage--;
              }

            })
            let rightbar = document.getElementById("rightbarHDL_" + this.id);
            rightbar.addEventListener("click", function (e) {

              if (vue.currentHDLPackage == vue.packagesHDL.length) {

              } else {

                vue.currentHDLPackage++;
              }
            })




          } else {
            //this.symbolSvg = {};
          }
        }

        if (this.$store.getters.sectionPrefix == "projm") {
          let place = "hdlsymbol_select_" + vue.id;


          let hdlsymbol_select = document.getElementById(place);

          let eventListener = function (e) {

            let id = "HDLsymbol__" + vue.revisionId;
            if (vue.parent == "Search") {
              id = "searchsymbol__" + vue.revisionId;
            }
            if (vue.parent == "modalSearchParts") {
              id = "modalSearchPartssymbol__" + vue.revisionId;
            }

            vue.currentHDLSymbolObject.name = this.value;
            //vue.currentHDLSymbolName = this.value;

            let img = document.getElementById("HDLsymbol__" + vue.revisionId);
            if (img != null) {
              img.dataset.name = this.value;
            }

            const obj = {
              type: LibraryTypes.HDLSYMBOL,
              name: this.value,
              id: id,
              revisionId: vue.revisionId
            }


            vue.$store.dispatch("pm_getSvg", obj)
              .then((result) => {

                if (result != null) {

                  let id = result.id;

                  vue.loadSVG(result, id, vue.revisionId, LibraryTypes.HDLSYMBOL);


                }

              })


          }

          hdlsymbol_select.addEventListener("change", eventListener);
        }
        


      },
      async loadSVG(result, id, revisionId, libType){
        

        let place = document.getElementById(id);
          let pinplace = document.getElementById("pin_" + id);

          let loaderplace = document.getElementById("loader_" + id);
          
          if (loaderplace != null) {
            
            loaderplace.classList.add("nodisplay");
            
          }
          
          if (place != null) {
            place.innerHTML = "";
            if (result.noImage == false) {

              
              place.classList.remove("nodisplay");
              
              if (pinplace != null && libType == LibraryTypes.PART) {
                pinplace.classList.remove("nodisplay");
              }
              let svgData = await new Response(result).text();
              var parser = new DOMParser();
              var doc = parser.parseFromString(svgData, "image/svg+xml");
              doc.documentElement.setAttribute("width", 200);
              doc.documentElement.setAttribute("height", 200);

              place.appendChild(doc.documentElement);
              
            } else {
              

              let classList = place.classList;
              let t = [];
              for (let i = 0, lei = classList.length; i < lei; i++){
                t.push(classList[i]);
              }
              if (!t.includes("nodisplay")) {
                
                place.classList.add("nodisplay");
              } 
              if (pinplace != null && libType == LibraryTypes.PART) {
                pinplace.classList.add("nodisplay");
              }

            }

            
            
            
        
        // let place = document.getElementById(id);
        
        // if (place != null){
        //   place.innerHTML = "";
        //   let pinplace = document.getElementById("pin_" + id);

        //   if (result.noImage == false) {
        //     if (libType == "footprint") {
        //       place.classList.add("image-footprint");
        //     } else {
        //       place.classList.add("image-symbol");
        //     }

        //     place.classList.add("image-zoom");


        //     if (pinplace != null && libType == LibraryTypes.PART) {
        //       pinplace.classList.remove("nodisplay");
        //     }
        //     let svgData = await new Response(result).text();
        //     var parser = new DOMParser();
        //     var doc = parser.parseFromString(svgData, "image/svg+xml");
        //     doc.documentElement.setAttribute("width", 200);
        //     doc.documentElement.setAttribute("height", 200);

        //     place.appendChild(doc.documentElement);

        //   } else {
        //     if (libType == "footprint") {
        //       place.classList.remove("image-footprint");
        //     } else {
        //       place.classList.remove("image-symbol");
        //     }

        //     place.classList.remove("image-zoom");
        //     place.innerHTML = "<p>No image<br></p>";
        //     if (pinplace != null) {
        //       pinplace.classList.add("nodisplay");
        //     }
        //   }
          
          

          if (place.dataset.type == LibraryTypes.PART || place.dataset.type == LibraryTypes.SYMBOL) {

            this.buildSymbolViewer(place, revisionId);
          }
          if (place.dataset.type == PartPropertiesType.HDLSYMBOL) {

            this.buildHDLSymbolViewer(place, revisionId);
          }
        }
        
      },
      async loadLibraryProps(data, type) {
        
        let vue = this;
        const obj = {
          revisionId: data.revisionId
        }

        this.$store.dispatch("lm_getLibrary", obj)
        .then((result) => {


            console.log(result)

          if (result.status == "OK") {
            let libraryType = "";

            for (let i = 0, lei = result.data.length; i < lei; i++) {
              if (result.data[i].type == LibraryPropertiesType.LIBRARYTYPE) {
                libraryType = result.data[i].value.display;
              }
            }
          
            if (type == PartPropertiesType.SYMBOL) {
              
              let img = document.getElementById("symbol__" + vue.revisionId);
              
              if (img != null) {
                img.dataset.type = libraryType;
              }

            }
          
            if (type == PartPropertiesType.FOOTPRINT) {
              vue.buildLibraryFootprintTable(result.data, data);
            }
            if (type == PartPropertiesType.SYMBOL || type == PartPropertiesType.HDLSYMBOL) {
              vue.buildLibrarySymbolTable(result.data, data);
            }
              
              
            }
        })
      },
      cleanLibraryProps(idL) {
        
        let place = document.getElementById(idL);
        if (place == null) {
          return
        }
        place.innerHTML = "";
      },
      buildLibraryFootprintTable(libraryData, status) {

        let place = document.getElementById(status.idL);
        if (place == null) {
          return
        }
        place.innerHTML = "";
        let str = this.lang.label_Properties + ":<br>";
        str += "<table class=\"library-table\">";

        for (let i = 0, lei = libraryData.length; i < lei; i++) {
          let prop = libraryData[i];
          if (prop.type != "library number" && prop.type != "library type" && prop.type != "image"){
            if (prop.name != null) {
              str += "<tr class=\"prop-tr\">";
              let value = "";
              if (prop.value != null) {
                value = prop.value.display;
              } else {
                value = "";
              }
              str += "<td>" + prop.name + "</td><td>" + value + "</td>";

              str += "</tr>";
            }
        }
        }

        str += "</table>";

        place.innerHTML = str;
        
      },
      buildLibrarySymbolTable(libraryData, status) {

        let place = document.getElementById(status.idL);
        if (place == null) {
          return
        }
        place.innerHTML = "";

        let str = this.lang.label_Properties + ":<br>";
        str += "<table class=\"library-table\">";

        for (let i = 0, lei = libraryData.length; i < lei; i++) {
          let prop = libraryData[i];
          if (prop.type != "library number" && prop.type != "library type" && prop.type != "image") {
            if (prop.name != null) {
              str += "<tr class=\"prop-tr\">";
              let value = "";
              if (prop.value != null) {
                value = prop.value.display;
              } else {
                value = "";
              }
              str += "<td>" + prop.name + "</td><td>" + value + "</td>";

              str += "</tr>";
            }
          }
        }

        str += "</table>";

        place.innerHTML = str;

      },
      prepareData(data){

        for (let i = 0, lei = data.length; i < lei; i++){
          if (data[i].value == null){
            data[i].value = {
              display: "",
              filter: "",
              sort: ""
            }
          }

          if (data[i].type == "library type") {
            this.libraryType = data[i].value.display;
          }
        }

        this.buildTable(data)
      },
      prepareDataAssembly(data){

        
        this.buildTableAssembly(data)


    },
    pinsToggle() {

      let vue = this;
      let checkboxPinOptions = document.getElementsByClassName('checkboxPinOption');


      for (var i = 0; i < checkboxPinOptions.length; i++) {
        checkboxPinOptions[i].addEventListener('click', function () {

          let svg = document.getElementById("symbol__" + vue.revisionId);

          const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')

          const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')

          if (this.checked == true) {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "none";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "block";
            }


          } else {
            for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
              pinsNumberlayers[i].style.display = "block";
            }
            for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
              pinsNameslayers[i].style.display = "none";
            }


          }


        })
      }
    },
        buildTable(_dataTable){
          
          this.imageTrig = false;
          this.symbolTrig = false;
          this.symbolHDLTrig = false;
          this.footprintTrig = false;


          var tableplace = document.getElementById(this.id);
          if (tableplace == null){
            return
          }
          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_"+this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          table.setAttribute("style", "width:100%;");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;

          let cols =  [
            { "data": "id" },
            { "data": "priority" },
            { "data": "name" },
            { "data": "value" },

          ]

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            {
              name: "Priority",
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Name,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Value,
              alignInColumn: "left",

            },

          ]

          var header = "";
          var columnDefs = [];
          var len = columns.length;
          let trigSymbol = false;
          let trigHDLSymbol = false;
          let trigFootprint = false;
          for (var i = 0; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function ( data, type, row, meta ) {
                  if (data == null) {
                    data = "";
                  }

                  data = $.fn.dataTable.render.text().display(data);
                  if (data.display != undefined) {
                    data.display = $.fn.dataTable.render.text().display(data.display);
                  }

                  if (meta.col == 0){
                    return data;
                  }
                  if (meta.col == 1){
                    return data;
                  }
                  if (meta.col == 2) {
                    let ln = "";
                    if (row.type == PartPropertiesType.SYMBOL){
                      let value = row.value.display.split(",");
                      if (value.length > 1){
                        ln = " (" + value.length + ")";
                      }
                      
                      
                    }
                    if (row.type == PartPropertiesType.FOOTPRINT){
                      let value = row.value.display.split(",");
                      if (value.length > 1){
                        ln = " (" + value.length + ")";
                      }
                                         
                      
                    }
                    if (row.type == PartPropertiesType.HDLSYMBOL){
                      let value = row.value.display.split(",");
                      if (value.length > 1){
                        ln = " (" + value.length + ")";
                      }
                                         
                      
                    }
                    return data + ln;
                  }
                  if (meta.col == 3) {
                    
                    if (row.type == "part number"){

                      return data.display;
                    }
                    
                    if (row.type == "image") {

                      // if (_vue.libraryType == LibraryTypes.PADSTACK) {
                      //   return "<img src=\"/static/noimage_pads.svg\" class=\"image-footprint\">";
                      // }
                      // if (data.display == "") {
                      //   return "<img src=\"/static/noimage.svg\" class=\"image-footprint\">";
                      // }
                      let bar = "";
                      let pinOption = "";

                      let id = "library__" + _vue.revisionId;
                      if (_vue.libraryType == LibraryTypes.PART || _vue.libraryType == LibraryTypes.SYMBOL) {
                        if (_vue.parent == "Search") {
                          id = "searchsymbol__" + _vue.revisionId;
                        } else if (_vue.parent == "modalSearchParts") {
                          id = "modalSearchPartssymbol__" + _vue.revisionId;
                        } else {
                          id = "symbol__" + _vue.revisionId;
                        }

                        pinOption = "<span id=\"pin_" + id + "\" class=\"pin-symbol nodisplay\"><input class=\"checkboxPinOption\" type=\"checkbox\" value=\"\"> " + _vue.lang.label_pinSwitch + "</span>";

                        let barid = "bar_symbol__" + _vue.revisionId + "_" + _vue.id;
                        bar = "<div id=\"" + barid + "\" class=\"bar-symbol\"></div>"; 
                      }

                      if (_vue.libraryType == LibraryTypes.FOOTPRINT || _vue.libraryType == LibraryTypes.MECHANICAL) {
                        if (_vue.parent == "Search") {
                          id = "searchfootprint__" + _vue.revisionId;
                        } else if (_vue.parent == "modalSearchParts") {
                          id = "modalSearchPartsfootprint__" + _vue.revisionId;
                        } else {
                          id = "footprint__" + _vue.revisionId;
                        }


                      }
                      let classU = "image-zoom image-footprint nodisplay";
                      if (_vue.parent == "modalSearchParts") {
                        classU = "";

                      }

                      let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3\"><span class=\"spinner-border spinner-border-sm \" aria-hidden=\"true\"> </span></div>";

                      let image = loader + "<div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"" + _vue.libraryType + "\" class=\"" + classU + "\"></div>" + bar  + pinOption;


                      const obj = {
                        type: _vue.libraryType,
                        name: data.display,
                        id: id,
                        revisionId: _vue.revisionId
                      }

                      if (data.display != "") {
                        if (_vue.imageTrig === false) {
                          _vue.imageTrig = true;

                          let sectionPrefix = _vue.$store.getters.sectionPrefix;
                          if (_vue.parent == "modalSearchParts") {
                            sectionPrefix = "pm";

                          }
                          
                          if (_vue.$store.getters.selectedPartBomRow.libraries == true) {
                            sectionPrefix = "lm"
                          }

                          _vue.$store.dispatch(sectionPrefix + "_getSvg", obj)
                            .then((result) => {

                              if (result != null) {


                                let id = result.id;
                                _vue.loadSVG(result, id, _vue.revisionId, _vue.libraryType);


                              }

                            })
                        }

                      } else {
                        image = data.display;
                      }

                      return image;
                    }
                    if (row.type == "mpn_image") {
                      if ((data.display.indexOf("http://") != -1) || (data.display.indexOf("https://") != -1)) {

                        return "<img class=\"img-thumbnail img-fluid\" height='40px' src='" + data.display + "'>";
                      }
                      return ""
                    }
                    if (row.type == "text"){

                      return data.display;
                    }
                    if (row.type == "description") {

                      return data.display;
                    }
                    if (row.type == "value"){

                      return data.display;
                    }
                    if (row.type == "type"){

                      return data.display;
                    }
                    if (row.type == PartPropertiesType.PART || row.type == PartPropertiesType.SYMBOL){
                      
                      if (trigSymbol == false) {

                        let symbols = data.display.split(",");
                        let place = "symbol_select_" + _vue.id;

                        let select = "<select  data-type=\"" + row.type + "\" class=\"form-control input-props symbol_select\" id=\"" + place + "\">";
                        for (let j = 0, lej = symbols.length; j < lej; j++) {
                          let selected = "";
                          if (j == 0) {
                            selected = "selected=\"selected\"";
                            _vue.currentSymbolObject.name = symbols[j].trim();
                          }

                          select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                        }
                        select += "</select>";




                        let id = "symbol__" + _vue.revisionId;
                        if (_vue.parent == "Search") {
                          id = "searchsymbol__" + _vue.revisionId;
                        }
                        if (_vue.parent == "modalSearchParts") {
                          id = "modalSearchPartssymbol__" + _vue.revisionId;
                        }
                        let idL = "libsymbolprop__" + _vue.revisionId;
                        let barid = "bar_symbol__" + _vue.revisionId + "_" + _vue.id;
                        trigSymbol = true;
                        let pinOption = "<span id=\"pin_" + id + "\" class=\"pin-symbol nodisplay\"><input class=\"checkboxPinOption\" type=\"checkbox\" value=\"\"> " + _vue.lang.label_pinSwitch + "</span>";

                        let classU = "image-zoom image-symbol nodisplay";
                        if (_vue.parent == "modalSearchParts") {
                          classU = "";

                        }

                        let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3\"><span class=\"spinner-border spinner-border-sm \" aria-hidden=\"true\"> </span></div>";
                        
                        let image = select + loader + "<br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"" + row.type + "\" class=\"" + classU + "\"></div><div id=\"" + barid + "\" class=\"bar-symbol\"></div>" + pinOption + "<div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"symbol\" class=\"\"></div>";


                        const obj = {
                          type: LibraryTypes.PART,
                          name: symbols[0],
                          id: id,
                          revisionId: _vue.revisionId
                        }

                        if (symbols[0] != "") {
                          
                          if (_vue.symbolTrig === false) {
                            _vue.symbolTrig = true;
                            
                            let sectionPrefix = _vue.$store.getters.sectionPrefix;
                            if (_vue.parent == "modalSearchParts") {
                              sectionPrefix = "pm";


                            }
                            if (_vue.$store.getters.selectedPartBomRow.libraries == true) {
                              sectionPrefix = "lm"
                            }
                            

                            _vue.$store.dispatch("pm_getSvg", obj)
                              .then((result) => {

                                if (result != null) {

                                  let id = result.id;

                                  _vue.loadSVG(result, id, _vue.revisionId, LibraryTypes.PART);


                                }

                              })

                            const objL = {
                              type: LibraryTypes.PART,
                              name: _vue.currentSymbolObject.name,
                              idL: idL
                            }
                            
                            _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                              .then((result) => {
                                console.log(result)
                                if (result.data != null) {



                                  _vue.loadLibraryProps(result.data, row.type);


                                } else {
                                  _vue.cleanLibraryProps(idL);
                                }

                              })
                          }
                        } else {
                          image = data.display;
                        }

                        return image;
                      } else {

                      }
                    }
                    if (row.type == PartPropertiesType.HDLSYMBOL) {

                      if (trigHDLSymbol == false) {

                        //let symbol = data.display;
                        let symbols = data.display.split(",");
                        let place = "hdlsymbol_select_" + _vue.id;

                        let select = "<select class=\"form-control input-props hdlsymbol_select\" id=\"" + place + "\">";
                        for (let j = 0, lej = symbols.length; j < lej; j++) {
                          let selected = "";
                          if (j == 0) {
                            selected = "selected=\"selected\"";
                            
                            _vue.currentHDLSymbolObject.name = symbols[j].trim();
                          }

                          select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                        }
                        select += "</select>";




                        let id = "HDLsymbol__" + _vue.revisionId;
                        if (_vue.parent == "Search") {
                          id = "searchsymbol__" + _vue.revisionId;
                        }
                        if (_vue.parent == "modalSearchParts") {
                          id = "modalSearchPartssymbol__" + _vue.revisionId;
                        }
                        let classU = "image-zoom image-symbol nodisplay";
                        if (_vue.parent == "modalSearchParts") {
                          classU = "";

                        }
                        
                        let idL = "libHDLsymbolprop__" + _vue.revisionId;
                        let barid = "bar_HDLsymbol__" + _vue.revisionId + "_" + _vue.id;
                        trigHDLSymbol = true;

                        let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3\"><span class=\"spinner-border spinner-border-sm \" aria-hidden=\"true\"> </span></div>";

                        let image = select + loader + "<br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"hdl symbol\" class=\"" + classU + "\"></div><div id=\"" + barid + "\" class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"hdl symbol\" class=\"\"></div>";


                        const obj = {
                          type: LibraryTypes.HDLSYMBOL,
                          name: symbols[0],
                          id: id,
                          revisionId: _vue.revisionId
                        }

                        if (symbols[0] != "") {

                          if (_vue.symbolHDLTrig === false) {
                            _vue.symbolHDLTrig = true;

                            let sectionPrefix = _vue.$store.getters.sectionPrefix;
                            if (_vue.parent == "modalSearchParts") {
                              sectionPrefix = "pm";


                            }
                            if (_vue.$store.getters.selectedPartBomRow.libraries == true) {
                              sectionPrefix = "lm"
                            }


                            _vue.$store.dispatch("pm_getSvg", obj)
                              .then((result) => {

                                if (result != null) {

                                  let id = result.id;

                                  _vue.loadSVG(result, id, _vue.revisionId, LibraryTypes.HDLSYMBOL);


                                }

                              })

                            const objL = {
                              type: LibraryTypes.HDLSYMBOL,
                              name: _vue.currentHDLSymbolObject.name,
                              idL: idL
                            }

                            _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                              .then((result) => {
                                console.log(result)
                                if (result.data != null) {



                                  _vue.loadLibraryProps(result.data, row.type);


                                } else {
                                  _vue.cleanLibraryProps(idL);
                                }

                              })
                          }
                        } else {
                          image = data.display;
                        }

                        return image;
                      } else {

                      }
                    }
                    if (row.type == PartPropertiesType.FOOTPRINT){

                      if (trigFootprint == false) {
                        trigFootprint = true;
                        let id = "footprint__" + _vue.revisionId;
                        if (_vue.parent == "Search") {
                          id = "searchfootprint__" + _vue.revisionId;
                        }
                        if (_vue.parent == "modalSearchParts") {
                          id = "modalSearchPartsfootprint__" + _vue.revisionId;
                        }
                        let idL = "libfootprintprop__" + _vue.revisionId;

                        let classU = "image-zoom image-footprint nodisplay";
                        if (_vue.parent == "modalSearchParts") {
                          classU = "";

                        }

                        let loader = "<div id=\"loader_" + id + "\" class=\"d-flex justify-content-center mb-3\"><span class=\"spinner-border spinner-border-sm \" aria-hidden=\"true\"> </span></div>";

                        let image = data.display + loader + "<br><br><div id=\"" + id + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"footprint\" class=\"" + classU + "\"></div><div id=\"" + idL + "\" data-revisionid=\"" + _vue.revisionId + "\" data-name=\"" + data.display + "\" data-type=\"footprint\" class=\"\"></div>";


                        const obj = {
                          type: LibraryTypes.FOOTPRINT,
                          name: data.display,
                          id: id,
                          revisionId: _vue.revisionId
                        }

                        if (data.display != "") {
                          
                          if (_vue.footprintTrig === false) {
                            _vue.footprintTrig = true;
                            let sectionPrefix = _vue.$store.getters.sectionPrefix;
                            if (_vue.parent == "modalSearchParts") {
                              sectionPrefix = "pm";

                            }
                            if (_vue.$store.getters.selectedPartBomRow.libraries == true) {
                              sectionPrefix = "lm"
                            }
                            
                            _vue.$store.dispatch("pm_getSvg", obj)
                              .then((result) => {

                                if (result != null) {


                                  let id = result.id;
                                  _vue.loadSVG(result, id, _vue.revisionId, LibraryTypes.FOOTPRINT);


                                }

                              })

                            const objL = {
                              type: LibraryTypes.FOOTPRINT,
                              name: data.display,
                              idL: idL
                            }

                            _vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                              .then((result) => {
                                console.log(result)
                                if (result.data != null) {

                                  _vue.loadLibraryProps(result.data, row.type);

                                } else {
                                  _vue.cleanLibraryProps(idL);
                                }

                              })
                          }
                        } else {
                          image = data.display;
                        }

                        return image;
                      } else {

                      }
                    }
                    if (row.type == "rohs"){

                      return data.display;
                    }
                    if (row.type == "date"){

                      return data.display;
                    }
                    if (row.type == "library number") {

                      return data.display;
                    }
                    
                    return data.display;
                  }

                }
              }

              columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name)
            th.appendChild(tx);

          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= _dataTable;
          json.myColumnFormats = columns;
          json.select = false;
          json.columns = cols;
          json.columnDefs = columnDefs;
          json.order = [1, "asc"];
          json.initComplete = function () {

            _vue.pinsToggle();


          }

          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }



          this.mainTable = $('#t_'+this.id).DataTable(json);


          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );
          this.mainTable.column( 1 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }

          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          let image_zoom = document.getElementsByClassName("image-zoom");

          if (image_zoom != null) {

            for (let i = 0, lei = image_zoom.length; i < lei; i++) {
              image_zoom[i].addEventListener("click", function (e) {


                let currentLib = this.dataset.name;
                if (this.dataset.type == PartPropertiesType.PART || this.dataset.type == PartPropertiesType.SYMBOL) {
                  currentLib = _vue.currentSymbolObject.name;
                }

                let source = "pm";
                if (_vue.$store.getters.selectedPartBomRow.libraries == true) {
                  source = "lm"
                }

                const svgObject = {
                  type: this.dataset.type,
                  name: currentLib,
                  id: this.dataset.type + "__" + this.dataset.revisionid,
                  revisionId: this.dataset.revisionid,
                  source: source
                }

                const langObj = {
                  modal_Title: currentLib,
                  label_pinSwitch: _vue.lang.label_pinSwitch
                }

                const obj = {
                  title: currentLib,
                  text: "",
                  type: "zoom_svg",
                  buttons: 1,
                  buttonName: _vue.lang.modal_ZoomSvg.button_Close,
                  size: "xl",
                  lang: langObj,
                  funcNo: "",
                  funcYes: "",
                  funcCustom: "",
                  svgObject: svgObject
                };

                _vue.$store.dispatch("showModalComponent", obj);

              })

            }

          }

        },
        buildTableAssembly(_dataTable){
          

          
          
          var tableplace = document.getElementById(this.idAssembly);

          if (tableplace == null){
            return;
          }

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_"+this.idAssembly);
          table.setAttribute("class", "table table-striped table-bordered");
          
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var _vue = this;

          let cols =  [
            { "data": "revisionId" },
            { "data": "partNumber" },
            { "data": "revision" },
            { "data": "quantity" },

          ]

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_PartNumber,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Revision,
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Quantity,
              alignInColumn: "left",

            },

          ]

          var header = "";
          var columnDefs = [];
          var len = columns.length;
          let trigSymbol = false;
          let trigHDLSymbol = false;
          let trigFootprint = false;
          for (var i = 0; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
                targets: i,
                className: classname,
                render: function ( data, type, row, meta ) {
                  if (data == null) {
                    data = "";
                  }

                  data = $.fn.dataTable.render.text().display(data);
                  if (data.display != undefined) {
                    data.display = $.fn.dataTable.render.text().display(data.display);
                  }

                  if (meta.col == 0){
                    return data;
                  }
                  if (meta.col == 1){
                    return data;
                  }
                  
                  
                  return data;
                }
              }

              columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(columns[i].name)
            th.appendChild(tx);

          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= _dataTable;
          json.myColumnFormats = columns;
          json.select = false;
          json.columns = cols;
          json.columnDefs = columnDefs;
          json.order = [1, "asc"];
          json.initComplete = function () {

            
        
          
          }
          

          if ($.fn.dataTable.isDataTable("#t_"+this.idAssembly)) {
              this.mainTable.destroy();
              
          }



          this.mainTable = $('#t_'+this.idAssembly).DataTable(json);


          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );
          //this.mainTable.column( 1 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_" + this.idAssembly + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }

          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

        },
      }

  }
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";
.QuickViewBomPartComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $redfont;
    }
    .green{
      color: #247f3e;
    }

    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }
    hr{
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .img-thumbnail {
      max-width: 200px;
      max-height: 200px;

      margin-top: 3px;
      margin-bottom: 3px;
    }

    .image-symbol {
      margin: 0px;
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-top: 3px;
      margin-bottom: 3px;
      margin-left: 2px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      display: block;

    }

    .image-footprint {
      background-color: #ffffff;
      //border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-top: 3px;
      margin-bottom: 5px;
      margin-left: 2px;
      overflow: hidden;
      width: 200px;
      height: 200px;

    }

    .image-zoom {
      cursor: zoom-in;
    }

    svg {
      display: block;
      width: 200px;
      height: 200px;
      overflow: hidden;

    }

    .bar-symbol {
      margin-top: 5px;
      margin-bottom: 5px;
      width: 200px;
    }

    .symbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .hdlsymbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .library-table{
      margin-left: 3px;
      margin-right: 5px;
      margin-top: 2px;
      margin-bottom: 5px;
      width: 99%;
    }
    .input-viewer {
      width: 110px !important;

    }
    .btn{
      margin: 0px !important;
      
    }
    .btn-bar{
      height: 26.8px !important;
      margin: 0px;
    }
    .checkboxPinOption{
      margin-left: 0px;
      margin-bottom: 5px;
    }
    .pin-symbol {
       margin-left: 5px;
    }
    .nodisplay{
      display: none !important;
    }
    .loader{
      margin: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/QuickViewBomPartComponent.vue